import { atom } from "../app-jotai";

import type { User } from "./api";

// undefined = not checked yet, null = checked and logged out
export const currentUserAtom = atom<User | null | undefined>(undefined);

// the currently active screen when logged in; null = working on an
// unfiled/new (not-yet-saved) screen
export const activeScreenIdAtom = atom<string | null>(null);

export const authPageStateAtom = atom<
  { isOpen: false } | { isOpen: true; mode: "signup" | "login" }
>({ isOpen: false });

// the full-screen "welcome back" dashboard listing projects/screens,
// shown automatically right after login/signup (and reachable via the menu)
export const dashboardOpenAtom = atom(false);

export const adminPanelOpenAtom = atom(false);
